import PrivacyNoticeComponent from './privacy-notice.component'

export default PrivacyNoticeComponent
